import React from 'react'

function PrizeIcon({ width, height, className }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} className={className} fill="currentColor" viewBox="0 0 18.001 18.001">
            <path id="Vector_-_2025-02-19T115121.954" data-name="Vector - 2025-02-19T115121.954" d="M4,18V16H8V12.9a5.368,5.368,0,0,1-2.187-1.037A4.485,4.485,0,0,1,4.4,9.951,4.853,4.853,0,0,1,1.263,8.313,4.817,4.817,0,0,1,0,5V4A1.924,1.924,0,0,1,.588,2.588,1.931,1.931,0,0,1,2,2H4V0H14V2h2a1.927,1.927,0,0,1,1.413.588A1.922,1.922,0,0,1,18,4V5a4.813,4.813,0,0,1-1.263,3.313A4.851,4.851,0,0,1,13.6,9.951a4.485,4.485,0,0,1-1.412,1.913A5.352,5.352,0,0,1,10,12.9V16h4v2ZM4,7.8V4H2V5a2.859,2.859,0,0,0,.55,1.713A3,3,0,0,0,4,7.8Zm10,0a3,3,0,0,0,1.45-1.088A2.857,2.857,0,0,0,16,5V4H14Z" />
        </svg>
    )
}

export default PrizeIcon